import { render, staticRenderFns } from "./add2cart.vue?vue&type=template&id=063990e4"
import script from "./add2cart.vue?vue&type=script&lang=js"
export * from "./add2cart.vue?vue&type=script&lang=js"
import style0 from "./add2cart.vue?vue&type=style&index=0&id=063990e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports